$(document).ready(function () {

  //Set sort direction
  var url = new URL(window.location.href);
  var sortField = url.searchParams.get('sort');
  var sortDirection = url.searchParams.get('direction');

  if (sortField && sortDirection) {
    $('.sort-summaries').removeClass('asc desc');
    $('.sort-summaries[data-sort="' + sortField + '"]').addClass(sortDirection);
  }

  $(document).on('click', '.sort-summaries', function (e) {
    e.preventDefault();

    var $header = $(this);
    var sortField = $header.data('sort');
    var currentDirection = $header.hasClass('asc') ? 'asc' : ($header.hasClass('desc') ? 'desc' : null);
    var newDirection = (currentDirection === 'asc') ? 'desc' : 'asc';

    $('.sort-summaries').removeClass('asc desc');
    $header.addClass(newDirection);

    var url = new URL(window.location.href);
    url.searchParams.set('sort', sortField);
    url.searchParams.set('direction', newDirection);
    window.location.href = url.toString();

  });


  function toggleConfirmButton() {
    const anyChecked = $('.item-checkbox:checked').length > 0;
    $('#confirm-construction-date').prop('disabled', !anyChecked);
  }

  toggleConfirmButton();

  $(document).on('change', '.item-checkbox, #check-all-checkbox', function() {
    toggleConfirmButton();
  });

  $('#confirm-construction-date').on('click', function() {
    const checkedIds = $('.item-checkbox:checked').map(function() {
      return $(this).data('item-id');
    }).get();
    if (checkedIds.length === 0) return;
    $.post('/summaries/final_confirm', { ordered_item_ids: checkedIds }, function(res) {
      if(res.success) {
        const url = new URL(window.location.href);
        url.searchParams.set('show_acceptance', 'exist');
        window.location.href = url.toString();
      } else {
        alert(res.message);
      }
    });
  });

  function initRealtimeDatePickers() {
    $('.change-realtime-date').daterangepicker({
      locale: ja_date_locale,
      singleDatePicker: true,
      autoUpdateInput: false,
      autoApply: true,
    });

    $('.change-realtime-date').off('apply.daterangepicker').on('apply.daterangepicker', function (ev, picker) {
      let format = $(this).data('format') || 'YYYY/MM/DD';
      var data = picker.startDate.format(format);
      var ordered_item_id = $(this).data('ordered-item-id');
      var name = $(this).data('name');
      var checkboxItem = $(this).closest('tr').find('.item-checkbox');
      $.ajax({
        method: 'put',
        url: `/ordered_items/${ordered_item_id}/change_realtime_date`,
        data: { [name]: data, },
        success: function(res) {
          if (res.status) {
            if (name === 'acceptance_date') {
              $(`#acceptance-date-${ordered_item_id}`).html(`${data}`);
              $(`#rm-acceptance-date-${ordered_item_id}`).removeClass('hidden');
            } else if (name === 'construction_date') {
              $(`#construction-date-${ordered_item_id}`).html(`${data}`);
              $(`#rm-construction-date-${ordered_item_id}`).removeClass('hidden');
            } else if (name === 'deposit_date') {
              $(`#deposit-date-${ordered_item_id}`).html(`${data}`);
              $(`#rm-deposit-date-${ordered_item_id}`).removeClass('hidden');
            } else {
              checkboxItem.prop('disabled', true);
              checkboxItem.prop('checked', false);
              $(`#expected-construction-date-${ordered_item_id}`).html(`${data}`);
              $(`#rm-expected-construction-date-${ordered_item_id}`).removeClass('hidden');
            }
            if (name === 'construction_date' || name === 'acceptance_date') {
              let constructionDate = $(`#construction-date-${ordered_item_id}`).html() || (name === 'construction_date' ? data : '');
              let acceptanceDate = $(`#acceptance-date-${ordered_item_id}`).html() || (name === 'acceptance_date' ? data : '');
              if (constructionDate && acceptanceDate) {
                checkboxItem.prop('disabled', false);
              }
            }
            toggleConfirmButton();
          } else {
            alert(res.message)
          }
        }
      })
    });
  }

  initRealtimeDatePickers();

  // list.on('updated', function() {
  //   initRealtimeDatePickers();
  // });

  $(document).on('click', '.remove-acceptance, .remove-expected-construction, .remove-construction-date, .remove-deposit-date', function() {
    var order_item_id = $(this).data('order-item-id');
    var name = $(this).data('name');
    var checkboxItem = $(this).closest('tr').find('.item-checkbox');
    $.ajax({
      method: 'put',
      url: `/ordered_items/${order_item_id}/change_realtime_date`,
      data: { [name]: null },
      success: function(res) {
        if (res.status) {
          if (name === 'acceptance_date') {
            $(`#acceptance-date-${order_item_id}`).html('');
            $(`#rm-acceptance-date-${order_item_id}`).addClass('hidden');
          } else if (name === 'construction_date') {
            $(`#construction-date-${order_item_id}`).html('');
            $(`#rm-construction-date-${order_item_id}`).addClass('hidden');
          } else if (name === 'deposit_date') {
            $(`#deposit-date-${order_item_id}`).html('');
            $(`#rm-deposit-date-${order_item_id}`).addClass('hidden');
          } else {
            checkboxItem.prop('disabled', true);
            checkboxItem.prop('checked', false);
            $(`#expected-construction-date-${order_item_id}`).html('');
            $(`#rm-expected-construction-date-${order_item_id}`).addClass('hidden');
          }
          if (name === 'construction_date' || name === 'acceptance_date') {
            const constructionDateElem = $(`#construction-date-${order_item_id}`);
            const acceptanceDateElem = $(`#acceptance-date-${order_item_id}`);

            const constructionDate = name === 'construction_date' ? '' : (constructionDateElem.html() || '');
            const acceptanceDate = name === 'acceptance_date' ? '' : (acceptanceDateElem.html() || '');

            if (!constructionDate || !acceptanceDate) {
              checkboxItem.prop('disabled', true);
              checkboxItem.prop('checked', false);
            }
            toggleConfirmButton();
          }
        } else {
          alert(res.message)
        }
      }
    })
  })
});
